import { AuthServiceV2 } from './Services/api/v2/auth.service';
import { RateService } from './Services/api/v2/rate.service';
import { BasketService } from './Services/api/v2/basket.service';
import { BasketStoreService } from './Services/stores/basket.store';
import { TranslateStaticAlias, TranslatePlaceholderDynamicAlias } from './Common/Directives/translation';
import { RouterModule } from '@angular/router';
import { ViewGuard } from './Guards/view.guard';
import { HttpRequestInterceptor } from './Interceptors/http-request.interceptor';
// Angular
import { NgModule, ModuleWithProviders, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Modules

// Custom classes
import { SpaContext } from './Classes/spacontext';
import { Doors } from './Classes/doors.class';
import { ConfirmLeaveGuard } from './Guards/confirm-leave.guard';

// Directives

// Components
import { VisibaPaymentComponent } from './Components/visibaPayment.component';
import { MediaTestMiniComponent } from './Components/mediaTestMini.component';
import { DynamicFormComponent } from './Components/DynamicForm/dynamicForm.component';
import { DfqYesNoComponent } from './Components/DynamicForm/question-yesno.component';
import { VisibaStepComponent } from './Components/visibaStep.component';
import { MessagingComponent } from './Components/messaging.component';

// Services
import { SpaEventService } from './Services/spaEvents.service';
import { GeneralService } from './Services/general.service';
import { SurveyService } from './Services/api/v2/survey.service';
import { UserFilesService } from './Services/api/v2/userfiles.service';
import { ErrHandler } from './error.handler';
import { DropInQueueService } from './Services/Queue/dropin-queue.service';
import { DfqMultiChoiceComponent } from './Components/DynamicForm/question-multichoice.component';
import { DfqMultilineComponent } from './Components/DynamicForm/question-multiline.component';
import { DfqSingleChoiceRadioComponent } from './Components/DynamicForm/question-singlechoiceradio.component';
import { DfqSingleChoiceSelectComponent } from './Components/DynamicForm/question-singlechoiceselect.component';
import { succesBox } from './Components/succesBox.component';
import { MessagingInjectable } from './Injectables/messaging.injectable';
import { CiscoMeetingServerService } from './Services/ciscoMeetingServer.service';
import { VisibaApiHttp } from './Classes/visibaHttp.class';
import { PageLoadHandler } from './Classes/PageLoadHandler';
import { UnitService } from './Services/api/v2/Units/units.service';
import { PaymentServiceV2 } from './Services/api/v2/Units/payment.service';
import { DropInUnitServiceV2 } from './Services/api/v2/Units/dropIn.service';
import { MessagingServiceV2 } from './Services/api/v2/messaging.service';
import { MessagingServiceV2 as MessagingUnitServiceV2 } from './Services/api/v2/Units/messaging.service';
import { IdentityServiceV2 } from './Services/api/v2/identity.service';
import { ScheduledDataService } from './Services/scheduled-data';
import { TimeslotServiceV2 } from './Services/api/v2/Units/timeslot.service';
import { DropInServiceV2 } from './Services/api/v2/dropin.service';
import { CasesServiceV2 } from './Services/api/v2/cases.service';
import { AppointmentsServiceV2 } from './Services/api/v2/appointments.service';
import { DynamicFormServiceV2 } from './Services/api/v2/Units/dynamic-form.service';
import { ConditionServiceV2 } from './Services/api/v2/Units/condition.service';
import { WebContentButtonsService } from './Services/api/v2/Units/webContentButtons.service';
import { ExternalDataService } from './Services/api/v2/Units/external-data.service';
import { PhysicalLocationService } from './Services/api/v2/Units/physical-location.service';
import { LicenceHolderServiceV2 } from './Services/api/v2/licenceholder.service';
import { Autosize } from './Common/Directives/autosize.directive';
import { visibaProgressBar } from './Common/Directives/visibaProgressBar';
import { TranslateService } from './Common/Services/translate.service';
import { VisibaSvgIconRepository } from './Common/Directives/visibaSvgIconRepository';
import { AudioPlayerService } from './Common/Services/audioPlayer.service';
import { VisibaSvg } from './Common/Directives/visibaSvg';
import { VisibaSelectComponent } from './Common/Directives/visibaSelect';
import { VisibaDatepickerComponent } from './Common/Directives/visibaDatepicker';
import { VisibaTimepickerComponent } from './Common/Directives/visibaTimepicker';
import { VisibaTelComponent } from './Common/Directives/visibaTel';
import { VisibaNationalIdentityNumberComponent } from './Common/Directives/visibaNationalIdentityNumber';
import { VisibaInputComponent } from './Common/Directives/visibaInput';
import { AlignHeight } from './Common/Directives/html';
import { VisibaGoogleChart } from './Common/Directives/visibaGoogleChart';
import { VisibaICDComponent } from './Common/Directives/visibaICD.component';
import { ImageViewerComponent } from './Common/Components/imageviewer.component';
import { ToggleSwitchComponent } from './Common/Components/toggle-switch.component';
import { AutoStick } from './Common/Directives/autoStick.directive';
import { VisibaSaveButtonComponent } from './Common/Directives/visibaSaveButton';
import { VisibaAlertComponent } from './Common/Directives/visibaAlert';
import { DateDisplayPipe } from './Common/Pipes/dateDisplayPipe';
import { SafeHtmlPipe } from './Common/Pipes/safeHtmlPipe';
import { TranslatePipe, TranslateAllowEmptyPipe } from './Common/Pipes/translate.pipe';
import { ConsolePipe } from './Common/Pipes/consolePipe';
import { Helper } from './Common/Helpers/helper';
import { SpaLogger } from './Common/Classes/Global/spalogger.class';
import { ConfirmPhoneNumberComponent } from './Components/confirmPhoneNumber';
import { NotificationComplianceComponent } from './Components/notificationCompliance.component';
import { ModalComponent } from './Components/modal.component';
import { ModalService } from './Services/modalService';
import { NotificationSettingsService } from './Services/api/v2/notificationSettings.service';
import { AuthContextService } from './Services/authContext.service';
import { ApplicationService } from './Services/application.service';
import { DateService } from './Services/date.service';
import { RedRobinService } from './Services/red-robin.service';
import { IdentityFactoryService } from './Services/flexible_patient_buttons.service/identity_factory.service';
import { FlexiblePatientButtonsService } from './Services/flexible_patient_buttons.service/mod';
import { UnitApiService } from './Services/api/v2/units_api.service';
import { TimeSlotLockApiService } from './Services/api/v2/timeslot_lock.service';
import { AppointmentFlowService } from './Views/Appointment/appointment-flow.service';
import { SemanticViewComponent } from './Components/semantic-view.component';
import { TrapFocusDirective } from './Common/Directives/trapFocus.directive';
import { OutcomesService } from './Services/outcomes.service';
import { UsageAgreementsService } from './Services/api/v2/usageAgreements.service';
import { RegistrationService } from './Services/api/v2/registration.service';
import { SmsAuthService } from './Services/api/v2/smsAuth.service';

@NgModule({
	imports: [CommonModule, FormsModule, HttpClientModule, ReactiveFormsModule, RouterModule],
	declarations: [
		// Directives
		VisibaSvg,
		Autosize,
		VisibaSelectComponent,
		VisibaDatepickerComponent,
		VisibaTimepickerComponent,
		VisibaTelComponent,
		VisibaNationalIdentityNumberComponent,
		VisibaInputComponent,
		AlignHeight,
		VisibaGoogleChart,
		VisibaICDComponent,
		VisibaPaymentComponent,
		MediaTestMiniComponent,
		ImageViewerComponent,
		ToggleSwitchComponent,
		VisibaStepComponent,
		AutoStick,
		TrapFocusDirective,
		DynamicFormComponent,
		DfqYesNoComponent,
		DfqMultiChoiceComponent,
		DfqMultilineComponent,
		DfqSingleChoiceRadioComponent,
		DfqSingleChoiceSelectComponent,
		VisibaSaveButtonComponent,
		MessagingComponent,
		succesBox,
		visibaProgressBar,
		VisibaAlertComponent,
		TranslateStaticAlias,
		TranslatePlaceholderDynamicAlias,
		ConfirmPhoneNumberComponent,
		NotificationComplianceComponent,
		ModalComponent,
		SemanticViewComponent,
		// Pipes
		DateDisplayPipe,
		SafeHtmlPipe,
		TranslatePipe,
		TranslateAllowEmptyPipe,
		ConsolePipe,
	],
	exports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		// Directives
		VisibaSvg,
		Autosize,
		VisibaSelectComponent,
		VisibaDatepickerComponent,
		VisibaTimepickerComponent,
		VisibaTelComponent,
		VisibaNationalIdentityNumberComponent,
		VisibaInputComponent,
		AlignHeight,
		VisibaGoogleChart,
		VisibaICDComponent,
		VisibaPaymentComponent,
		MediaTestMiniComponent,
		ImageViewerComponent,
		ToggleSwitchComponent,
		VisibaStepComponent,
		AutoStick,
		TrapFocusDirective,
		DynamicFormComponent,
		DfqYesNoComponent,
		DfqMultiChoiceComponent,
		DfqMultilineComponent,
		DfqSingleChoiceRadioComponent,
		DfqSingleChoiceSelectComponent,
		VisibaSaveButtonComponent,
		MessagingComponent,
		succesBox,
		visibaProgressBar,
		VisibaAlertComponent,
		TranslateStaticAlias,
		TranslatePlaceholderDynamicAlias,
		ConfirmPhoneNumberComponent,
		ModalComponent,
		SemanticViewComponent,
		// Pipes
		DateDisplayPipe,
		SafeHtmlPipe,
		TranslatePipe,
		TranslateAllowEmptyPipe,
		ConsolePipe,
	],
})
export class SharedModule {
	static forRoot(): ModuleWithProviders<any> {
		return {
			ngModule: SharedModule,
			providers: [
				// additional providers
				VisibaApiHttp,
				Helper,
				SpaEventService,

				GeneralService,
				UserFilesService,

				FlexiblePatientButtonsService,
				IdentityFactoryService,

				TranslateService,
				DropInQueueService,
				Doors,
				CiscoMeetingServerService,
				VisibaSvgIconRepository,
				MessagingInjectable,
				UnitService,
				WebContentButtonsService,
				ExternalDataService,
				PhysicalLocationService,
				RedRobinService,
				OutcomesService,

				UnitApiService,

				// V2 API services
				DynamicFormServiceV2,
				AppointmentsServiceV2,
				DropInServiceV2,
				DropInUnitServiceV2,
				IdentityServiceV2,
				TimeslotServiceV2,
				MessagingServiceV2,
				MessagingUnitServiceV2,
				PaymentServiceV2,
				CasesServiceV2,
				ConditionServiceV2,
				LicenceHolderServiceV2,
				RateService,
				AuthServiceV2,
				TimeSlotLockApiService,
				SurveyService,
				UsageAgreementsService,
				RegistrationService,
				SmsAuthService,

				// APP services
				ScheduledDataService,

				AppointmentFlowService,
				AudioPlayerService,

				BasketService,
				BasketStoreService,

				ModalService,
				NotificationSettingsService,

				AuthContextService,
				ApplicationService,
				DateService,

				{ provide: ViewGuard, useClass: ViewGuard },
				{ provide: ConfirmLeaveGuard, useClass: ConfirmLeaveGuard },
				{ provide: SpaContext, useClass: SpaContext },
				{ provide: SpaLogger, useClass: SpaLogger },
				{
					provide: HTTP_INTERCEPTORS,
					useClass: HttpRequestInterceptor,
					multi: true,
				},
				{ provide: ErrorHandler, useClass: ErrHandler },
				{ provide: PageLoadHandler, useClass: PageLoadHandler },
			],
		};
	}
}
